function isBrowser() {
  return typeof window !== "undefined";
}
function isServer() {
  return typeof window === "undefined" || "Deno" in globalThis;
}

export { isBrowser, isServer };
